import {validations} from "IncompleteInfoV2/validations";
import {FIELD_NAMES} from "profile/enums";
import {IProfile} from "StateInterface";
import {IErrors, IReferences} from "IncompleteInfoV2/References/index";

export const getInitialState = (profile: IProfile): IReferences => {
    const references = profile[FIELD_NAMES.REFERENCES];
    return {
      [FIELD_NAMES.TOTAL_DEPENDENTS]: profile.financeBasicInfo.numDependents,
      [FIELD_NAMES.REFERENCES]: [
        {
            [FIELD_NAMES.REFERENCE_NAME]: references[0] && (references[0][FIELD_NAMES.REFERENCE_NAME]),
            [FIELD_NAMES.REFERENCE_MOBILE]: references[0] && (references[0][FIELD_NAMES.REFERENCE_MOBILE]),
        }, {
            [FIELD_NAMES.REFERENCE_NAME]: references[1] && (references[1][FIELD_NAMES.REFERENCE_NAME]),
            [FIELD_NAMES.REFERENCE_MOBILE]: references[1] && (references[1][FIELD_NAMES.REFERENCE_MOBILE]),
        },
    ]};
};

export const referencesValidation = (profile: IReferences): IErrors => {
    const errors = {[FIELD_NAMES.REFERENCES]:
      profile[FIELD_NAMES.REFERENCES].map(item => validations(item)), ...validations({[FIELD_NAMES.TOTAL_DEPENDENTS]:
      profile[FIELD_NAMES.TOTAL_DEPENDENTS]})}
    if (profile[FIELD_NAMES.REFERENCES][0][FIELD_NAMES.REFERENCE_NAME] === profile[FIELD_NAMES.REFERENCES][1][FIELD_NAMES.REFERENCE_NAME]) {
        errors[FIELD_NAMES.REFERENCES][1][FIELD_NAMES.REFERENCE_NAME] =  "Reference name can't be same";
    }
    if (profile[FIELD_NAMES.REFERENCES][0][FIELD_NAMES.REFERENCE_MOBILE] === profile[FIELD_NAMES.REFERENCES][1][FIELD_NAMES.REFERENCE_MOBILE]) {
        errors[FIELD_NAMES.REFERENCES][1][FIELD_NAMES.REFERENCE_MOBILE] =  "Reference mobile number can't be same";
    }
    return errors;
};
